export const usePageStore = defineStore('page', {
  state: () => ({
    breadCrumb: [],
    sectionHandle: null,
    newsLetterListId: null,
  }),

  getters: {
    getBreadCrumb: (state) => {
      return state.breadCrumb;
    },
  },

  actions: {
    setBreadCrumb(crumbs) {
      this.breadCrumb = crumbs;
    },

    setSectionHandle(sectionHandle) {
      this.sectionHandle = sectionHandle;
      this.setNewsletterList(sectionHandle);
    },

    /**
     * set newsletter list by locale
     * overwrite for academy section to academy-list-de
     */
    setNewsletterList(sectionHandle) {
      const {
        $i18n: { locales, locale },
        $config,
      } = useNuxtApp();

      let listId;
      if (sectionHandle === 'academy') {
        listId = $config.public.academy.newsletterListId;
      } else {
        const currentLocaleSettings = locales.value.find((l) => l.code === locale.value);
        listId = currentLocaleSettings.newsletterListId;
      }
      this.newsLetterListId = listId;
    },

    reset() {
      this.breadCrumb = [];
    },
  },
});
